import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationClientService } from '../../services/configuration-client.service';

@Component({
  selector: 'app-maintenance-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.css',
})
export class MaintenanceBannerComponent implements OnInit {
  bannerEnabled = false;
  bannerMessage = '';

  constructor(private configurationClientService: ConfigurationClientService) {}

  ngOnInit(): void {
    this.configurationClientService.getMaintenanceBanner().subscribe({
      next: (banner) => {
        this.bannerEnabled = banner.enabled;
        this.bannerMessage = banner.message;
      },
      error: () => {},
    });
  }
}
